module.exports = __webpack_public_path__ + "static/media/apple-calendar-icon@2x.c21e0ab0.png";